import { Component, Inject } from "@angular/core";
import { Subscription } from 'rxjs';

import { MatDialogRef } from "@angular/material";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SessionStorageService } from "../../services/session-storage.service";
import { SnackbarService } from './../../services/snackbar.service';
import { ContractSignedService } from "./contract-signed.service";

@Component({
    selector: "contract-signed",
    template: require('./contract-signed.component.html'),
    styles: [require('./contract-signed.component.less')],
    providers: [ContractSignedService, SnackbarService],
})
export class ContractSignedComponent {
    popupLoading: boolean;
    isIOSChrome: boolean = false;
    downloadApiSubscription: Subscription;

    constructor(
        private _contractSignedService: ContractSignedService,
        private _mdlSnackbarService: SnackbarService,
        public contractSignedPopup: MatDialogRef<any>,
        private _sessionStorageService: SessionStorageService,
        @Inject(MAT_DIALOG_DATA) public contractData: any,
        @Inject('utilService') private utilService: any
    ) {
        this.checkIOSChrome();
    }

    closePopup() {
        this._sessionStorageService.readItem('approval_from_action_required_list').then((data: any) => {
            if (data && window.location.href.indexOf('docusign-approval-complete') === -1) {
                this.utilService.showActionRequiredListOnRedirection.next({show: true});
                this._sessionStorageService.removeItem('approval_from_action_required_list');
            }
        });

        this.contractSignedPopup.close();
    }

    fetchContractDocument(isDownload: boolean) {
        this.popupLoading = true;
        this.downloadApiSubscription?.unsubscribe();
        this.downloadApiSubscription = this._contractSignedService.downloadDocusign(this.contractData.id)
            .subscribe(res => {
                this.popupLoading = false;

                if (isDownload) {
                    this.downloadPDF(res, this.contractData.id);
                } else {
                    this.printPDF(res);
                }
            },
                error => {
                    this.popupLoading = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                });
    }

    downloadPDF(response: any, id: any) {
        if (typeof window.navigator.msSaveBlob === 'function') {
            window.navigator.msSaveBlob(response, "Patient-" + id + "-" + new Date().getTime() + ".pdf");
        } else {
            const blob = response;
            const link = document.createElement('a');
            const binaryData: any = [];

            binaryData.push(blob);
            link.href = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }))
            link.download = "Patient-" + id + "-" + new Date().getTime() + ".pdf";
            // append the link to the document body
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        }
        this.closePopup();
    }

    printPDF(response: any) {
        const blob = response;
        const blobUrl = URL.createObjectURL(blob);

        if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
            this.previewAndPrintPDF(blobUrl);
            return;
        }

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = blobUrl;
        document.body.appendChild(iframe);
        setTimeout(() => {
            iframe.contentWindow.print();
            this.closePopup();
        }, 1000);
    }

    checkIOSChrome() {
        if (/iPhone|iPad|iPod/.test(navigator.userAgent) && /CriOS/.test(navigator.userAgent)) {
            this.isIOSChrome = true;
        }
    }

    previewAndPrintPDF(pdfUrl: any) {      
        const newTab = window.open(pdfUrl, '_blank');
        if (newTab) {
            setTimeout(() => URL.revokeObjectURL(pdfUrl), 10000);
        }
        this.closePopup();
    }

    ngOnDestroy() {
        this.downloadApiSubscription?.unsubscribe();
    }
}
